import React from 'react';
// import { useState } from 'react';
import classNames from 'classnames';
// import YouTube, { YouTubePlayer } from 'react-youtube';
import YouTube from 'react-youtube';

export const getYoutubeId = link => {
    // eslint-disable-next-line no-useless-escape
    const id = link?.match(/youtu(?:.*\/v\/|.*v\=|\.be\/)([A-Za-z0-9_\-]{11})/);
    return id ? id[1] : null;
};

export const YoutubeEmbed = ({ id, controls = true, className }) => (
    <div className={classNames(className, 'relative')}>
        <YouTube
            videoId={id}
            id={id}
            style={{ aspectRatio: '16/9', objectFit: 'cover', width: '100%', height: '100%' }}
            opts={{
                height: '100%',
                playerVars: {
                    controls: controls ? 1 : 0,
                },
            }}
            iframeClassName="w-full h-full aspect-video object-cover"
        />
    </div>
);

export default YoutubeEmbed;
